<LoadingData v-if="loading"></LoadingData><SingleBlog :singleBlogData="singleBlog" :allBlogsData="allBlogs" v-if="singleBlog &amp;&amp; !loading"></SingleBlog>